import type { EventsByDate } from '../../types/GroupsArrayType';
import type { SingleEventByDate } from '../../types/RowType';

export default function getRowEvents(eventsByDate: EventsByDate): SingleEventByDate {
  return Object.keys(eventsByDate).reduce((result, date) => {
    if (eventsByDate[date].length) {
      const event = eventsByDate[date].shift();
      result[date] = event;
    }
    return result;
  }, {});
}
